import React, { createContext, useContext, useState } from "react";

// Create the context
const AssessmentTabsContext = createContext();

// Create a provider component
export const AssessmentTabsProvider = ({ children }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const moveNext = () => {
    setSelectedTab(selectedTab + 1);
  };

  const moveBack = () => {
    setSelectedTab(selectedTab - 1);
  };

  const updateSelectedTab = (value) => {
    setSelectedTab(value);
  };

  return (
    <AssessmentTabsContext.Provider
      value={{ selectedTab, moveNext, moveBack, updateSelectedTab }}
    >
      {children}
    </AssessmentTabsContext.Provider>
  );
};

export const useAssessmentTabs = () => useContext(AssessmentTabsContext);
